"use strict";
import { SettingsToggle } from "components/AccountDrawer/SettingsToggle";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useEnabledChains } from "features/chains/hooks/useEnabledChains";
import { useHideSmallBalancesSetting } from "features/settings/hooks";
import { setHideSmallBalances } from "features/settings/slice";
export function SmallBalanceToggle() {
  const { t } = useTranslation();
  const hideSmallBalances = useHideSmallBalancesSetting();
  const dispatch = useDispatch();
  const { isTestnetModeEnabled } = useEnabledChains();
  const onToggle = () => {
    dispatch(setHideSmallBalances(!hideSmallBalances));
  };
  return <SettingsToggle
    title={t("settings.hideSmallBalances")}
    isActive={hideSmallBalances && !isTestnetModeEnabled}
    toggle={onToggle}
    disabled={isTestnetModeEnabled}
  />;
}
